import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

export function getStartDateOfTheWeek(date = new Date()) {
  return dayjs(date).startOf('isoWeek').toDate();
}

export function getEndDateOfTheWeek(date = new Date()) {
  return dayjs(date).endOf('isoWeek').toDate();
}

export function getStartDateOfTheMonth(date = new Date()) {
  return dayjs(date).startOf('month').toDate();
}

export function getEndDateOfTheMonth(date = new Date()) {
  return dayjs(date).endOf('month').toDate();
}
